<template>
    <div id="footer">
        <div id="footer-left"
             :class="classIsVisible"
        >
            <a class="btn-main-func"
               href="#"
               id="btn-toggle-allow-tool"
               :title="i18n.t('tooltip_active_tool')"
               @click.prevent = "toggleToolAllowed"
               :class="classIsAllowToolBtnActive"
               :style="styleIsAllowToolBtnActive"
            >
            </a>
            <!-- note we use stopPropagation upon click event here, so that the onEmptyAreaClicked method on Reader.vue can be bypassed !-->
            <a class="btn-main-func"
               :class="{active:  toolState.isShowToolbox}"
               href="#"
               id="btn-toggle-toolbox"
               :title="i18n.t('tooltip_toolbox')"
               @click.stop="toggleToolbox"
            >
                <img src="~/images/icon_toolbox.png">
            </a>
        </div>
        <div id="footer-middle">
            <slider :width="'100%'"
                    :height="'8px'"
                    :min="0"
                    :max="bookData.pagenames.length-1"
                    :step = "1"
                    :styleHandler="stylePageSliderHandler"
                    :styleBg="stylePageSliderBg"
                    id="slider-paging"
                    ref="refPageSlider"
                    @slider-sliding="onPageSliderSliding"
                    @slider-slided="onPageSliderSlided"
                    @slider-slide-to="onSliderSlideTo"
                    @slider-ready="onSliderReady"
                    v-if="bookData.pagenames && bookData.pagenames.length && renderPageSlider"
                    :class="classIsVisible"
            ></slider>
        </div>
        <div id="footer-right"
        >
            <a id="btn-toggle-double-page"
               class="btn-main-func wide"
               href="#"
               @click.prevent="togglePageMode"
               :title="i18n.t('tooltip_toggle_page_mode')"
               :class="[classBtnToggleDoublePage, classIsVisible]"
            >
                <img src="~images/icon_double_page.png"
                     v-show="pageState.pageMode === 'single'"
                >
                <img src="~images/icon_single_page.png"
                     v-show="pageState.pageMode === 'double'">
            </a>
            <btn-logout></btn-logout>
        </div>
        <tool-panel v-show="toolState.isShowToolbox"></tool-panel>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch, nextTick,inject}  from "vue"
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {useTool} from "@/modules/reader/tools/tools";
    import {usePaging}  from "@/modules/reader/book/paging";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import Slider from "@/views/lib/slider/Slider";
    import ToolPanel from "@/views/reader/tool/ToolPanel";
    import config from "@/config/config.json";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";
    import cssvar from '@/scss/_variables.scss';
    import BtnLogout from "@/views/footer/BtnLogout";

    const colorPrimary = cssvar.colorPrimary;
    const doublePageLabelDelimiterColor = cssvar.doublePageLabelDelimiterColor;

    export default {
        components:{
            Slider,
            ToolPanel,
            BtnLogout
        },
        props: {
            isLoadComplete:Boolean
        },
        setup(props, context) {

            const i18n = inject('i18n');
            const { togglePageMode, pageState, setCurrentPage} = usePaging();
            const { bookInfoState} = useBookInfo();
            const { bookData} = useDataLoader();
            const {pageResizeState}= usePageResize();
            const {
                toolState,
                toggleToolAllowed,
                togglePanel,
                toggleToolbox,
                closeToolBoxAndPanel,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER,
            } = useTool();

            const refPageSlider  = ref(null);

            const stylePageSliderHandler = {
                width:"120px",
                height:"24px",
                background:"#fcd549",
                color:"#000",
                fontSize:"13px",
                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.5), 0 2px 2px rgba(0,0,0,0.3), 0 0 4px 1px rgba(0,0,0,0.2), inset 0 3px 2px rgba(255,255,255,.22), inset 0 -3px 2px rgba(0,0,0,.15), inset 0 20px 10px rgba(255,255,255,.12), 0 0 4px 1px rgba(0,0,0,.1), 0 3px 2px rgba(0,0,0,.2)",
                border: "1px solid rgba(0,0,0,0.15)",
                borderRadius: "10px"
            }

            const classIsVisible = computed(()=>{
                return {
                    "invisible": !props.isLoadComplete
                }
            })

            
            const classBtnToggleDoublePage = computed(()=> {
                //on non-touch device, not allow to switch between single/double page mode if :
                //1. browser size is too small (see pageState.isAllowTogglePageMode logic for details)
                //2. last page has reached, and total page count is an odd number,
                //on touch device, if portrait direction, not allow to switch page mode.
               return {
                   "disabled": (!pageState.isAllowTogglePageMode || (pageState.currentPage[0] === pageState.pageCount - 1 && pageState.currentPage[0] % 2 === 0)) ? true : false
               }
            });
            const onPageSliderSliding = (e) => {
                closeToolBoxAndPanel();
                refPageSlider.value.setLabel(bookData.pagenames[e]);
            }

            const onPageSliderSlided = (e) => {
                setCurrentPage(e)
            }

            const onSliderSlideTo = (e) => {
                setCurrentPage(e);
                refPageSlider.value.setLabel(bookData.pagenames[e]);
            }

            const classIsAllowToolBtnActive = computed(()=>{
                return {
                    "active": (toolState.isAllowed),
                    //"tool-allowed-brush": (toolState.isAllowed && toolState.activeTool === TOOL_BRUSH),
                    //"tool-allowed-highlight": (toolState.isAllowed && toolState.activeTool === TOOL_HIGHLIGHTER),
                    "tool-allowed-note": (toolState.isAllowed && toolState.activeTool === TOOL_NOTE),
                    "tool-note-disabled": ( toolState.activeTool === TOOL_NOTE && toolState.isNoteDisabled),
                    "tool-allowed-eraser": (toolState.isAllowed && toolState.activeTool === TOOL_ERASER)
                }
            })

            //TODO: very dirty, please clean: move all const to data, and try to see if possible not to repeat in ToolIcons.vue
            const styleIsAllowToolBtnActive = computed(()=>{

                if (toolState.isAllowed && toolState.activeTool === TOOL_BRUSH) {
                    let index = config.reader.tool.colors.indexOf(toolState.brushSetting.color);
                    return {
                        backgroundPosition: `${-36 * index}px 0`
                    }

                } else if (toolState.isAllowed && toolState.activeTool === TOOL_HIGHLIGHTER) {
                    let index = config.reader.tool.colors.indexOf(toolState.highlightSetting.color);
                    return {
                        backgroundPosition: `${-36 * index} -36px`
                    }
                }
            })


            const updateSlider = ()=>{
                if ( refPageSlider.value && !refPageSlider.value.isSliding) {
                    let targetPage = pageState.currentPage[0];

                    refPageSlider.value.setValue(targetPage)
                    refPageSlider.value.setLabel(bookData.pagenames[targetPage]);

                    if (pageState.isRightPageAvailable) {
                        let pageLabelLeft = bookData.pagenames[pageState.currentPage[0]];
                        let pageLabelRight = bookData.pagenames[pageState.currentPage[1]]
                        refPageSlider.value.setValue(targetPage + 0.5)

                        let doublePageLabel = "";
                        if (pageLabelLeft.length + pageLabelRight.length >= config.reader.pageSliderLabelLongCharCount) {
                            doublePageLabel = `<span style="font-size:11px; line-height:11px;">${pageLabelLeft} <span style="color:${doublePageLabelDelimiterColor};">|</span> <span>${pageLabelRight}</span></span>`
                        } else {
                            doublePageLabel = `${pageLabelLeft} <span style="color:${doublePageLabelDelimiterColor};">|</span>  ${pageLabelRight}`
                        }
                        refPageSlider.value.setLabel(doublePageLabel);
                    } else {
                        refPageSlider.value.setLabel(bookData.pagenames[targetPage]);
                    }
                }
            }

            const onSliderReady = (e) => {
                updateSlider();
            }

            //If orientation is changed on touch devices, the page slider width will not update automatically. Use renderPageSlider to render again
            const renderPageSlider = ref(true);

            const updateFooterOnOrientationChange = ()=>{

                renderPageSlider.value = false;
                //setTimeout(()=> {
                    nextTick(() => {
                        setTimeout(()=> {
                            renderPageSlider.value = true;
                        }, 300);
                    })
                //}, 200);
            }

            onMounted(() => {
                window.addEventListener("orientationchange",()=>{
                    //setTimeout(updateFooterOnOrientationChange, 200)
                    updateFooterOnOrientationChange();
                });

                updateFooterOnOrientationChange();

            })

            watch(
                () => pageState.currentPage,
                (newVal, oldVal) => {
                    updateSlider();
                }
            )

            watchEffect(()=>{
                //if zoom level is large enough and exceed the browser height, there will be vertical scrollbar at the right edge of the browser window.
                //The slider width will have to be updated again:
                /*
                if (pageResizeState.zoomLevel) {
                    updateFooterOnOrientationChange();
                }*/

                if (pageState.pageMode) {
                    closeToolBoxAndPanel();
                }
            })

            return {
                i18n,
                props,
                onPageSliderSliding,
                onPageSliderSlided,
                onSliderSlideTo,
                onSliderReady,
                isTouchDevice,
                renderPageSlider,
                stylePageSliderHandler,
                bookData,
                pageState,
                toolState,
                bookInfoState,
                styleIsAllowToolBtnActive,
                classIsAllowToolBtnActive,
                classBtnToggleDoublePage,
                classIsVisible,
                toggleToolAllowed,
                togglePanel,
                toggleToolbox,
                togglePageMode,
                refPageSlider,
                setCurrentPage,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER,
            }

        }
    }
</script>

<style scoped lang="scss">


    #btn-toggle-allow-tool {
        background: url("~images/tool_icon_set.png") -180px -72px;
        background-size:432px 108px;
    }

    .tool-allowed-brush {
        background-position: -396px 0 !important;
    }

    .tool-allowed-highlight {
        background-position-y: -36px !important;
    }

    .tool-allowed-note {
        background-position: -36 -72px !important;
    }

    .tool-note-disabled {
        opacity:0.5;
    }

    .tool-allowed-eraser {
        background-position: 0 -72px !important;
    }

    .invisible {
        visibility:hidden;
    }

    .page-label-splitter {
        color:#ffccdd;
    }
</style>